/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import Save from './save';
import metadata from './block.json';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
	title: metadata.title,
	/**
	 * @see ./edit.js
	 */
	attributes: {
		showCalendar: {
			type: 'boolean',
			default: true,
		},
		showCards: {
			type: 'boolean',
			default: true,
		},
		showList: {
			type: 'boolean',
			default: true,
		},
		showSearch: {
			type: 'boolean',
			default: true,
		},
		eventsPerPage: {
			type: 'number',
			default: 5,
		},
	},
	edit: Edit,
	save: Save
} );
